export default __webpack_public_path__ + "navigation-examples-embedded-navigation-960-a60362657915f57509ac9da422e5e069.webp";